import { useState } from "react";
import { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { ReactComponent as SendInvitePlane } from "../../Assets/Svg/SendInvitePlane.svg";
import { useUserStore } from "../../Context/store";
import { InputFocusBlue } from "../../Utils/Constant";

const createOption = (label) => ({
  label,
  value: label,
  id: label,
});

const TagsInput = ({
  contacts,
  setContacts,
  selectClass,
  // maxLimit = 10,
  resetState= ()=>{}
}) => {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const { user: loggedInUser } = useUserStore();
  // const navigate = useNavigate();

    const customStyles = {
      multiValue: (styles) => ({
        ...styles,
        backgroundColor: "#E8F5FB",
      }),
      multiValueLabel: (styles) => ({
        ...styles,
        color: "#424242",
      }),
      multiValueRemove: (styles) => ({
        ...styles,
        color: "#424242",
        ":hover": {
          backgroundColor: "#c1e7dd",
          color: "#0a431f",
        },
      }),
    };
  
    const CustomMultiValue = (props) => {
      return (
        <components.MultiValue {...props}>
          <span
            style={{ display: "flex", alignItems: "center" }}
            className="gap-2 "
          >
            <SendInvitePlane className="h-4 w-4" />{" "}
            <components.MultiValueLabel {...props} children={props.children} />{" "}
            {/* Include the label */}
          </span>
        </components.MultiValue>
      );
    };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        if (inputValue.toLowerCase() === loggedInUser?.email?.toLowerCase()) {
          setError("You are already added please enter another email");
          setInputValue("");
          return;
        }
        // if (contacts?.length >= (maxLimit - 1)) {
        //   event.preventDefault();
        //   handleUpgradePlan(ADD_USERS, () => {
        //     navigate(`/upgrade-plan?plan=base-plan`);
        //     resetState();

        //   });
        //   setError(`You can only add ${maxLimit} members including you`);
        //   setInputValue("");
        //   return;
        // }
        if (!isValidEmail(inputValue)) {
          setError("Please enter a valid email address.");
          return;
        }
        if (contacts.some((contact) => contact.value === inputValue)) {
          setInputValue("");
          setError("This email already added");
          return;
        }
        event.preventDefault();
        setContacts((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        setError("");
        break;
      default:
        setError("");
    }
  };

  const isValidEmail = (email) => {
    // Regular expression for basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <>
      <CreatableSelect
        inputId="tags"
        components={{
          DropdownIndicator: null,
          MultiValue: CustomMultiValue,
        }}
        inputValue={inputValue}
        isClearable={false}
        isMulti
        menuIsOpen={false}
        onChange={(newValue) => setContacts(newValue)}
        onInputChange={(newValue) => setInputValue(newValue)}
        onKeyDown={handleKeyDown}
        placeholder="Type an email and press Enter..."
        value={contacts}
        classNamePrefix={"react-select"}
        className={`max-w-full flex-1 shadow-shadowDebate rounded-md border border-debatePalette-shadow ${InputFocusBlue} ${selectClass}`}
        styles={customStyles || {}}
      />
      {error && (
        <p className="text-red-500 font-semibold text-sm mt-1">{error}</p>
      )}
    </>
  );
};

export default TagsInput;
